import { CartProductSchema } from 'graphql/generated';

export const getHasNotAvailable = (data: CartProductSchema[]) => {
  if (!data || !data.length) return false;
  return data.every((entity) => !entity.sku.isAvailable);
};
